import { render } from "./AwardDetailOct2023Page.vue?vue&type=template&id=3f13170e"
import script from "./AwardDetailOct2023Page.vue?vue&type=script&lang=js"
export * from "./AwardDetailOct2023Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__